import axios from "axios";
import VueCookie from "vue-cookie";

const http = axios.create({
    baseURL: process.env.VUE_APP_BASEURL,
    timeout: 1000 * 60 * 10,
    withCredentials: false,
    headers: {
        "Content-Type": "application/json; charset=utf-8"
    }
});
const errorCodeList = [10002];

// 前置拦截器
http.interceptors.request.use(
    config => {
        let token = VueCookie.get("token")
        if (token) config.headers['token'] = token
        // let session = VueCookie.get("session")
        // if (session) {
        //     config.headers['session'] = session
        // }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// 后置拦截器
http.interceptors.response.use(
    response => {
        const result = response.data;
        if (errorCodeList.includes(response.data.code)) {
            return Promise.reject(result);
        }
        return result;
    },
    error => {
        return Promise.reject(error);
    }
);

export default http;



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js